import { render, staticRenderFns } from "./FieldTranslationsDialog.vue?vue&type=template&id=ff12d76e"
import script from "./FieldTranslationsDialog.vue?vue&type=script&lang=js"
export * from "./FieldTranslationsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports